<template>
  <div class="exhibitions flex fd-c">
    <div class="item" v-for="(item, index) in list" :key="index">
      <div class="title-box flex fd-c listWOW fadeInDown" data-wow-duration="0.5s" data-wow-delay="0.2s" v-html="item.info"></div>
      <div class="list">
        <div class="list-item" v-for="(im, ix) in item.works" :key="ix">
          <img :src="im.pictures" class="listWOW fadeInDown" @click="picturesClick(item, ix)" data-wow-duration="0.5s" data-wow-delay="0.4s" alt="">
          <div class="txt-box flex fd-c listWOW fadeInDown" data-wow-duration="0.5s" data-wow-delay="0.6s" v-html="im.info"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findExhibitions } from '../../../api'
import { ImagePreview } from 'vant';
import { WOW } from "wowjs";
export default {
  components:{},
  props:{},
  data(){
    return {
      list: [],
    }
  },
  watch:{},
  computed:{},
  methods:{
    findExhibitions() {
          findExhibitions({
            page: 1,
            limit: 100,
            type: 2
          }).then(res=>{
              this.list = res.data.data.records
              this.$nextTick(()=>{
                  this.listWOW()
              })
          })
      },
      listWOW () {
        var wow = new WOW({
            boxClass: "listWOW",
            animateClass: "animated",
            offset: 0,
            mobile: true,
            live: true
        });
        wow.init();
     },
     picturesClick(item, index){
       console.log(item);
       var imagePreviewList = []
       for (var im of item.works) {
         imagePreviewList.push(im.pictures)
       }
       ImagePreview({
        images: imagePreviewList,
        startPosition: index,
      })
     }
  },
  created(){
    this.findExhibitions()
  },
  mounted(){}
}
</script>
<style scoped>
.exhibitions{
  width: 900px;
  margin: 0 auto;
}
.item{
  margin-top: 140px;
}
.item:nth-child(1){
  margin-top: 100px;
}
.title-box{
  width: 100%;
  margin-top: 10px;
}
.title-box>>>p{
  font-size: 14px!important;
  font-weight: 400!important;
  color: rgb(238,68,38)!important;
  line-height: 18px!important;
}
.list-item{
}
.exhibitions img{
  display: block;
  width: 100%;
  height: auto;
  margin-top: 50px;
}
.txt-box {
  margin-top: 19px;
}
.txt-box>>>p{
  font-size: 14px!important;
  font-weight: 400!important;
  color: #000000!important;
  line-height: 18px!important;
}
</style>